import { Font } from '@react-pdf/renderer'

// There are bizarre issues with fonts where we aren't able to use multiple fonts (e.g. different weights)
// from the same family. We limit ourselves to one font per family to avoid this issue.
export default function initPdfFonts(): void {
  Font.register({
    family: 'greycliffcf',
    fonts: [
      {
        src: 'https://assets.schoolhouse.world/fonts/greycliffcf/greycliffcf-bold-webfont.ttf',
        fontWeight: 'bold',
      },
    ],
  })

  Font.register({
    family: 'proximanova',
    fonts: [
      {
        src: 'https://assets.schoolhouse.world/fonts/proximanova/proximanova-regular.ttf',
        fontWeight: 400,
      },
    ],
  })

  Font.registerHyphenationCallback(word => [word])
}
